module.exports = __webpack_public_path__ + "img/4.67ac14a0.jpeg";